import { reactive, ref, computed, onMounted, watch, onBeforeMount } from '@vue/composition-api'

import store from '@/store'
import * as apiNote from '@/api/note'

export const NoteUserPermissionsList = (props, context) => {

  onMounted(() => {
    state.noteId = store.state.note.currentId
    state.shareClassification = store.state.note.detailEdit.share_classification

    // ウィンドウタイトル
    let shareClassificationName = ''
    if (state.shareClassification === 21) {
      shareClassificationName = '閲覧'
    } else if (state.shareClassification === 22) {
      shareClassificationName = '編集'
    }
    state.windowTitle = shareClassificationName + '可能なアカウント'

    // キーワード入力欄のフォーカス状態（SP専用）
    if (store.state.common.device === 'sp') {
      if (context.refs.focusInput) {
        context.refs.focusInput.addEventListener('focus', (event) => {
          state.isFocusedInput = true
        })
        context.refs.focusInput.addEventListener('blur', (event) => {
          state.isFocusedInput = false
        })
      }
    }

    state.isDataLoaded = false

    const currentId = store.getters['note/currentId']
    const detail = store.getters['note/detail']
    const createUserId = detail.create_user_id

    // ノート利用者権限一覧APIをコール
    const params = {
      id: currentId
    }
    apiNote
      .getUserPermissions(params)
      .then(response => {
        const { data } = response

        if (data.status === 0) {
          const allListWork = []
          for (let i = 0; i < data.users.length; i++) {
            const _userId = data.users[i].id
            const _shareClassification = data.users[i].share_classification
            if (
              _userId === createUserId || // ノート作成者は閲覧/編集可能であるため常にリストに表示
              _shareClassification === state.shareClassification // 権限が設定されている利用者
            ) {
              allListWork.push(data.users[i])
            }
          }
          state.allList = allListWork
          state.list = state.allList
        }
      })
      .finally(() => {
        state.isDataLoaded = true
      })
  })

  const state = reactive({
    profileId: computed(() => store.state.profile.id), // 自分(ログインユーザー)のID
    noteId: null, // 対象のノートID(新規作成の場合はnull)
    shareClassification: null, // 処理対象の共有区分(21=閲覧可、22=編集可)
    isFocusedInput: false, // テキストフィールドのフォーカス表示フラグ（SP用）

    windowTitle: '', // ウィンドウタイトル

    isDataLoaded: false,

    // 全リスト
    allList: [],

    // 表示中のリスト
    list: [],

    search_text: '',

    // ユーザー検索
    search: () => {
      const searchText = state.search_text.trim()

      // キーワードに一致する名前をもつユーザーを抽出し、新しい表示中のリストに設定する
      const listWork = []
      for (let i = 0; i < state.allList.length; i++) {
        const map = state.allList[i]
        const userName = map.name
        if (userName.indexOf(searchText) >= 0) {
          listWork.push(map)
        }
      }
      state.list = listWork
    }
  })

  const close = () => {
    context.emit('close')
  }

  return {
    state,
    close
  }
}
